module.exports = __webpack_public_path__ + "static/media/lehuilin_match_01.d88d889d.png";